<template src="./GoogleAccount.html"></template>

<script>
import { createNamespacedHelpers } from 'vuex';
import TopMenu from "@/components/settings/components/topMenu"

const { mapGetters, mapActions} = createNamespacedHelpers('settings/googleAccount');

export default {
  name: "GoogleAccount",
  components: {
    TopMenu,
  },
  data () {
    return {
      showOverlay: false,
      fieldsList: [
        {
          key: 'action',
          label: '-',
          sortable: false,
          tdClass: 'action-cell',
          thClass: 'action-cell'
        },
        {
          key: 'id',
          label: 'ID',
          sortable: true,
        },
        {
          key: 'apiKey',
          label: 'Ключ API',
          sortable: true
        },
        {
          key: 'isBlocked',
          label: 'Статус аккаунта',
          sortable: true
        },
        {
          key: 'priority',
          label: 'Приоритет',
          sortable: true
        },
        {
          key: 'charLimit',
          label: 'Лимит символов',
          sortable: true
        },
        {
          key: 'proxy',
          label: 'Прокси',
          sortable: true
        },
        {
          key: 'isWorkingProxy',
          label: 'Статус прокси',
          sortable: true
        },
        {
          key: 'charCounter',
          label: 'Символов в этом месяце',
          sortable: true
        },
        {
          key: 'totalChar',
          label: 'Символов всего',
          sortable: true
        },
        {
          key: 'errors',
          label: 'Ошибка',
          sortable: true
        },
        {
          key: 'created',
          label: 'Дата создания',
          sortable: true
        },
      ],
      editableFields: [
          'apiKey',
          'proxy',
          'isBlocked',
          'priority',
          'charLimit',
      ],
      requiredField: [
        'apiKey',
        'proxy',
      ],
      currentPage: 1,
      currentSort: 'id',
      currentSortDir: true,
      searchVal: '',
      newRowValue: {},
      reComputed: false,
      renderComponent: true,
    }
  },
  methods: {
    ...mapActions([
      'GET_DATA',
      'SAVE',
    ]),
    initPageSize: function () {
      let winHeight = window.innerHeight;
      winHeight = Math.round((winHeight - 205) / 26);
      this.$store.commit('settings/googleAccount/PER_PAGE', winHeight);
      this.currentPage = 1;
    },
    editCell: function (id, field) {
      // check if field is editable
      if (!this.editableFields.includes(field)) {
        return false;
      }
      let viewCell = this.$refs.dictionaryTable.$el.querySelectorAll('.t-cell');
      viewCell.forEach((val) => {
        val.style.display = 'block';
      });

      let editCell  = this.$refs.dictionaryTable.$el.querySelectorAll('.edit-cell');
      editCell.forEach((val) => {
        val.style.display = 'none';
      })

      this.$refs['cell_view_' + id +'_'+ field].style.display = 'none';
      if (this.$refs['cell_edit_' + id +'_'+ field].$el == undefined) {
        this.$refs['cell_edit_' + id +'_'+ field].style.display = 'block';
        this.$refs['cell_edit_' + id +'_'+ field].focus();
      } else {
        this.$refs['cell_edit_' + id +'_'+ field].$el.style.display = 'block';
        this.$refs['cell_edit_' + id +'_'+ field].$el.focus();
      }
    },
    changeCell: function (index, id, field) {
      this.$refs['cell_view_' + id +'_'+ field].style.display = 'block';
      if (this.$refs['cell_edit_' + id +'_'+ field].$el == undefined) {
        this.$refs['cell_edit_' + id +'_'+ field].style.display = 'none';
      } else {
        this.$refs['cell_edit_' + id +'_'+ field].$el.style.display = 'none';
      }
      // add new row
      if (this.GOOGLE_ACCOUNT_DATA.length == (index + 1)) {
        let buf = this.GOOGLE_ACCOUNT_DATA.splice(0);
        buf.push({
          id: '--',
          singularKey: '',
          singularValue: '',
          pluralKey: '',
          pluralValue: '',
          categoryName: '',
        });
        this.$store.commit('settings/googleAccount/GOOGLE_ACCOUNT_DATA', buf);
        this.$forceUpdate();
      }
    },
    removeRow: function (id) {
      if (Number.isInteger(id)) {
        this.$store.commit('settings/googleAccount/ADD_TO_DELETED_LIST', id);
      }
      let buf = Object.assign({}, this.GOOGLE_ACCOUNT_DATA)
      delete(buf[id])
      this.$store.commit('settings/googleAccount/GOOGLE_ACCOUNT_DATA', buf);
    },
    save: function () {
      this.SAVE({th: this});
    },
    addNew: function () {
      let key = 'new'+ Object.keys(this.GOOGLE_ACCOUNT_DATA).length
      this.newRowValue['id'] = key
      this.newRowValue['isWorkingProxy'] = true
      this.$set(this.GOOGLE_ACCOUNT_DATA, key, Object.assign({}, this.newRowValue))
      this.reComputed = !this.reComputed
      this.initNewValue()
      this.forceRerender()
    },
    initNewValue: function () {
      this.newRowValue = null
      this.newRowValue = {}
      for (let key in this.getEditableFieldsList) {
        this.newRowValue[this.getEditableFieldsList[key].key] = null;
      }
    },
    forceRerender: function () {
      this.renderComponent = false
      this.$nextTick(() => (
          this.renderComponent = true
      ))
    },
    statusToggle(id) {
      let buf = Object.assign({}, this.GOOGLE_ACCOUNT_DATA[id])
      buf.isBlocked = !buf.isBlocked
      this.$set(this.GOOGLE_ACCOUNT_DATA, id, buf)
    },
  },
  computed: {
    ...mapGetters([
      'GOOGLE_ACCOUNT_DATA',
      'CURRENT_PAGE',
      'PER_PAGE',
      'PARAMS',
    ]),
    getGoogleAccountData: function () {
      let buf = [];
      for(let key in this.GOOGLE_ACCOUNT_DATA) {
        buf.push(this.GOOGLE_ACCOUNT_DATA[key])
      }

      let search = this.searchVal.toLowerCase()
      buf = buf.filter((el) => {
        if (search.length == 0)
          return true

        let apiKey = el.apiKey.toLowerCase()
        let proxy = el.proxy.toLowerCase()
        let created = el.created.toLowerCase()
        let errors = el.errors.toLowerCase()
        return apiKey.indexOf(search) !== -1
            || proxy.indexOf(search) !== -1
            || created.indexOf(search) !== -1
            || errors.indexOf(search) !== -1
      });

      return buf
    },
    getEditableFieldsList: function () {
      return this.fieldsList.filter((el) => {
        return el.key !== 'id' && this.editableFields.includes(el.key) && el.key !== 'isBlocked'
      })
    },
  },
  watch: {
    currentPage(newVal) {
      this.$store.commit('settings/googleAccount/CURRENT_PAGE', newVal);
    },
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('settings') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
    this.currentPage = this.CURRENT_PAGE;
  },
  created() {
    this.initPageSize();
    if (Object.keys(this.GOOGLE_ACCOUNT_DATA).length === 0) {
      this.GET_DATA({th: this});
    }
    // fill new value skeleton
    this.initNewValue()
  }
}
</script>

<style scoped>
  .dictionary-type {
    width: 77px;
    float: right;
  }
  .cell-cursor {
    cursor: cell;
  }
  .t-cell {
    overflow: hidden;
    width: 100%;
    display: block;
  }
  .remove-button {
    float: left;
    height: 24px;
    line-height: 15px;
  }
  .save-but {
    float: right;
  }
  .search-box {
    width: 500px;
    float: left;
  }
  .edit-cell {
    height: 24px;
    line-height: 15px;
  }
  .but-cell-plus {
    width: 25px !important;
    flex: 0 0 1%;
    padding-left: 0px;
  }
  .edit-cell-box {

  }
  .grin-text {
    color: #72BB53;
  }
  .red-text {
    color: red;
  }
  .required:after {
    content:" *";
    color: red;
  }
</style>

<style>
  .table td.action-cell, .table th.action-cell {
    width: 25px;
  }
</style>